import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api } from '../services/api'

export default function ShareAccept() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const token = params.get('token')
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token) { setStatus('error'); setMessage('Neplatný odkaz.'); return }
    const authToken = localStorage.getItem('token')
    if (!authToken) {
      navigate(`/login?next=/share/accept?token=${token}`)
      return
    }
    api.post('/devices/share/accept', { token })
      .then(() => { setStatus('success') })
      .catch(err => { setStatus('error'); setMessage(err.response?.data?.error || 'Chyba') })
  }, [token, navigate])

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ backgroundColor: '#fff', borderRadius: 20, padding: 40, maxWidth: 400, width: '100%', textAlign: 'center', boxShadow: '0 4px 24px rgba(0,0,0,0.06)' }}>
        {status === 'loading' && <><div style={{ fontSize: 40, marginBottom: 16 }}>⏳</div><p style={{ color: '#888' }}>Spracovávam pozvánku...</p></>}
        {status === 'success' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#1a1a1a', margin: '0 0 8px' }}>Pozvánka prijatá!</h2>
            <p style={{ color: '#888', fontSize: 15, margin: '0 0 24px' }}>Zariadenie sa objavilo v tvojom dashboarde.</p>
            <button onClick={() => navigate('/dashboard')} style={{ padding: '12px 28px', borderRadius: 12, border: 'none', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
              Otvoriť dashboard
            </button>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: '#1a1a1a', margin: '0 0 8px' }}>Nepodarilo sa</h2>
            <p style={{ color: '#888', fontSize: 15, margin: '0 0 24px' }}>{message}</p>
            <button onClick={() => navigate('/dashboard')} style={{ padding: '12px 28px', borderRadius: 12, border: 'none', backgroundColor: '#2D7A3A', color: '#fff', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>
              Späť na dashboard
            </button>
          </>
        )}
      </div>
    </div>
  )
}
